module.exports = __webpack_public_path__ + "static/img/1486_phase_function_Paper_PointsHejduk_Prediction.40c7654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1486_phase_function_Paper_PointsHejduk_Prediction.png
// module id = E0Pp
// module chunks = 0